import { IResponse } from "../contracts/IResponse";
import { HttpMethodEnum } from "../enums/enums";
import { Claim } from "../models/Claim";
import { Dashboard } from "../models/Dashboard";
import { Partner } from "../models/Partner";
import { PartnerApplicationModel } from "../models/PartnerApplicationModel";
import { SendPasswordModel } from "../models/SendPasswordModel";
import { SignInModel } from "../models/SignInModel";
import { BaseService } from "./BaseService";

export class PartnerService extends BaseService {
    constructor() {
        super("partner")
    }

    SignIn(model: SignInModel): Promise<IResponse<Claim>> {
        return fetch(`${this.EndPoint}/signin`, { method: HttpMethodEnum.POST, body: JSON.stringify(model), headers:{ "Content-Type": "application/json" }}).then(response => response.json())
    }

    RequestNewPassword(model: SendPasswordModel): Promise<IResponse<Claim>> {
        return fetch(`${this.EndPoint}/request-new-password`, { method: HttpMethodEnum.POST, body: JSON.stringify(model), headers:{ "Content-Type": "application/json" }}).then(response => response.json())
    }

    Get(partnerID:number): Promise<IResponse<Partner>> {
        return fetch(`${this.EndPoint}/${partnerID}`, { method: HttpMethodEnum.GET, headers:{ "Content-Type": "application/json" }}).then(response => response.json())
    }

    GetDashboard(partnerID:number): Promise<IResponse<Dashboard>> {
        return fetch(`${this.EndPoint}/dashboard/${partnerID}`, { method: HttpMethodEnum.GET, headers:{ "Content-Type": "application/json" }}).then(response => response.json())
    }

    Apply(model: PartnerApplicationModel): Promise<IResponse<number>> {
        return fetch(`${this.EndPoint}/apply`, { method: HttpMethodEnum.POST, body: JSON.stringify(model), headers:{ "Content-Type": "application/json" }}).then(response => response.json())
    }
}